import React, { useState } from "react"
import { Link } from "react-router-dom"
import { useNavigateToPost } from "../../hooks/useNavigateToPost"
import { SmartDateFormat } from "../../util/dates"
import CommentSectionPreview from "../comments/CommentSectionPreview"
import { ShareUrlButton } from "../ShareUrlButton"
import { ShowHideButton } from "../shared/Button"
import { ReactionBlock } from "./ReactionBlock"
import RelatedPosts from "../RelatedPosts"
import PremiereHeader from "./PremiereHeader"
import clsx from "clsx"
import styles from "./styles.module.css"
import type { HeadlineDisplayConfig } from "../../types/headlineDisplay"

const localStyles = {
  header: "text-base md:text-2xl font-bold text-black-800 leading-none md:leading-tight",
  bandName: "text-gray-500 leading-none text-xs",
  postDate: "text-xs md:text-sm text-black-800 leading-none md:leading-normal",
  description: "text-xs md:text-sm text-gray-500 mt-1",
}

interface EditorialListItemShortProps {
  post: any
  adminMode?: boolean
  updateStatus?: () => void
  config?: HeadlineDisplayConfig
}

export const EditorialListItemShort = ({
  post,
  adminMode = false,
  updateStatus = () => {},
  config = { showComments: "full", showRelatedPosts: "full" },
}: EditorialListItemShortProps) => {
  const { showComments, showRelatedPosts } = config
  const [postStatus, setPostStatus] = useState(post.status)
  const navigateToPostScreen = useNavigateToPost(post.nada_path)

  return (
    <div>
      <PremiereHeader post={post} size="small" />
      <div className="flex gap-3 items-start">
        <div className="flex-1 min-w-0">
          <h2
            className={clsx(localStyles.header, "cursor-pointer", post.is_bn_premiere && styles.premiereTitle)}
            onClick={navigateToPostScreen}
          >
            {post.title}
            <ShareUrlButton nadaUrl={post.nada_url} renderMode="icon" alignment="align-middle" />
          </h2>

          <Link className={localStyles.bandName} to={post.local_path}>
            {post.band_name}
          </Link>

          <div className={localStyles.postDate}>
            Posted:&nbsp;
            {SmartDateFormat({ dateStr: post.published_at, includeTime: false })}
          </div>
        </div>

        {post.cover_image_url_large && (
          <div className="hidden sm:block w-1/4 flex-shrink-0">
            <img
              src={post.cover_image_url_large}
              alt={post.title}
              onClick={navigateToPostScreen}
              className="aspect-square object-cover w-full cursor-pointer"
            />
          </div>
        )}
      </div>

      <div className="mt-2">
        {post.subtitle && (
          <div className={localStyles.description}>{post.subtitle}</div>
        )}
        {post.editorial_blurb && (
          <div className={localStyles.description}>{post.editorial_blurb}</div>
        )}

        <RelatedPosts postId={post.id} nadaUrl={post.nada_url} mode={showRelatedPosts} />
        <div className="mt-6">
          <ReactionBlock
            contentType="Post"
            contentId={post.id}
            postId={post.id}
          />
        </div>
        <CommentSectionPreview postId={post.id} postPath={post.nada_url} mode={showComments} />
        {adminMode && (
          <ShowHideButton
            updateStatus={updateStatus}
            postStatus={postStatus}
            setPostStatus={setPostStatus}
          />
        )}
      </div>
    </div>
  )
}
